import { c as _c } from "react/compiler-runtime";
import { useMutation } from "@tanstack/react-query";
import { pythonRunner } from "#/features/codeRunner/lib/pythonRunner";

/**
 * Client-side Python formatting via Pyodide + Black (same worker as code execution).
 */
export const usePythonFormatCode = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
};
async function _temp(code) {
  const {
    formatted,
    error
  } = await pythonRunner.formatCode(code);
  if (error !== null) {
    throw new Error(error);
  }
  return formatted;
}